import Icon, {
	FormOutlined,
} from "@ant-design/icons";
import { Form, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import { DataCourse, DataModule, IClass, statusTypes } from "types";
import { ReactComponent as forumIcon } from "assets/forumIcon.svg";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import {
	AddBlockContentModal,
	AddClassModal,
	EditBlockContentModal,
	EditClassModal,
	MenuPage,
	ViemForumModal,
} from "components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { api } from "services/api";
import ProcessingModal from "components/Modals/ProcessingModal";
// import URLHelper from "utils/url";

export const ManageClasses: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEditClass, setIsOpenEditClass] = useState<boolean>(false);
	const [isOpenBlock, setIsOpenBlock] = useState<boolean>(false);
	const [isOpenEditBlock, setIsOpenEditBlock] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [editMode, setEditMode] = useState<boolean>(false);
	const [processing, setProcessing] = useState<boolean>(false);
	const [currentClassInfo, setCurrentClassInfo] = useState<IClass>();
	const [isOpenForum, setIsOpenForum] = useState<boolean>(false);
	const [files, setFiles] = useState<{ [k: string]: string }>({
		image: "",
		video: "",
		archive: "",
	});
	const [blocks, setBlocks] = useState<any[]>([]);
	const [selectedBlockId, setSelectedBlockId] = useState<number>(0);
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [fromCreate, setFromCreate] = useState<boolean>(false);
	// @ts-ignore
	const { state }: { state: { data: DataModule; generalState: DataCourse } } =
		useLocation();
	const [form] = Form.useForm();
	const [editClassForm] = Form.useForm();
	const navigate = useNavigate();
	

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { class: courseClass, forum },
			},
		} = await api.get(`/classes/${id}`);

		setCurrentClassInfo({ ...courseClass, forum });
	};

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "30%",
				};
			},
		},
		{
			title: "Criado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Autor",
			dataIndex: "author",
			key: "author",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => <p style={{ margin: 0 }}>{statusTypes[status]}</p>,
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						title="Editar"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEditClass(true);
						}}
					/>
					<Icon
						component={forumIcon}
						style={{ fontSize: "28px" }}
						className="group"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenForum(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.classes;
	}

	const { courseId } = useParams();
	const backToModules = () => {
		navigate(`/manage-courses/course/${courseId}`, {state: {data: state.generalState}})
	}

	return (
		<div className="m-classes">
			<AddClassModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				fromCreate={fromCreate}
				setFromCreate={setFromCreate}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpenBlock={setIsOpenBlock}
				courseStatus={courseStatus}
				blocks={blocks}
				setBlocks={setBlocks}
				setCourseStatus={setCourseStatus}
				setSelectedBlockId={setSelectedBlockId}
				setIsOpenEditBlock={setIsOpenEditBlock}
				setProcessing={setProcessing}
				titlePage={`Módulo - ${state.data.title}`}
				courseId={state.data.id}
				onCreated={handleRefresh}
			/>
			<EditBlockContentModal
				form={form}
				isOpen={isOpenEditBlock}
				setIsOpen={setIsOpenEditBlock}
				files={files}
				setFiles={setFiles}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				setEditMode={setEditMode}
				blocks={blocks}
				setBlocks={setBlocks}
				setFromCreate={setFromCreate}
				fromCreate={fromCreate}
				setProcessing={setProcessing}
				setSelectedBlockId={setSelectedBlockId}
				selectedBlockId={selectedBlockId}
			/>
			<AddBlockContentModal
				form={form}
				isOpen={isOpenBlock}
				setIsOpen={setIsOpenBlock}
				files={files}
				setFiles={setFiles}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				setBlocks={setBlocks}
				setFromCreate={setFromCreate}
				setProcessing={setProcessing}
				fromCreate={fromCreate}
				currentClassInfo={currentClassInfo}
			/>

			<EditClassModal
				form={editClassForm}
				isOpen={isOpenEditClass}
				setIsOpen={setIsOpenEditClass}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpenBlock={setIsOpenBlock}
				courseStatus={courseStatus}
				blocks={blocks}
				setBlocks={setBlocks}
				setEditMode={setEditMode}
				editMode={editMode}
				setProcessing={setProcessing}
				setCourseStatus={setCourseStatus}
				setSelectedBlockId={setSelectedBlockId}
				setIsOpenEditBlock={setIsOpenEditBlock}
				isOpenEditBlock={isOpenEditBlock}
				currentClassInfo={currentClassInfo}
				titlePage={`Módulo - ${state.data.title}`}
				courseId={state.data.id}
				onUpdated={handleRefresh}
			/>
			<ViemForumModal
				setIsOpen={setIsOpenForum}
				isOpen={isOpenForum}
				currentCourseData={currentClassInfo}
				isCourse={false}
			/>
			<ProcessingModal visible={processing} />

			<div className="m-classes__back-action">
				<button className="m-classes__back-action__btn" 					
						onClick={backToModules}
						>Voltar a Módulos</button>
			</div>

			<MenuPage 
				title="Aulas"
				subtitle={`Aulas do curso ${state.generalState.title}, módulo: ${state.data.title}`}
				tableColumns={columns} 
				sourceDataUrl={`/modules/${state.data.id}/classes`}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Aula" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por nome ou descrição"
			/>
		</div>
	);
};
